// Function to find and update the featured review once the elements are available
function updateFeaturedReview() {
    // Select the review list container
    const reviewList = document.querySelector('.yotpo-reviews-list');
  
    // Check if there are children with class "yotpo-review"
    const reviews = reviewList ? reviewList.querySelectorAll('.yotpo-review') : [];
  
    if (reviews.length > 0) {
        // Get the first review
        const firstReview = reviews[0];
  
        // Find the thumbnail and review content within the first review
        const reviewContent = firstReview.querySelector('.yotpo-review-content');
        const name = firstReview.querySelector('.yotpo-reviewer-name');
  
        // Check if the review content exists
        if (reviewContent) {
            // Find the "featured review" container by its id
            const featuredReview = document.getElementById('featured-review');
  
            if (featuredReview) {
                // Clear any existing content in the featured review div
                featuredReview.innerHTML = '';
                
                // Clone and append the review content
                const reviewContentClone = reviewContent.innerText;
                const readMoreText = "...Lue lisää";
                if (reviewContentClone.endsWith(readMoreText)) {
                    const wrappedContent = `<a href="#yotpo-app" is="review-link" data-smooth-scroll="">${reviewContentClone}</a>`;
                    featuredReview.innerHTML += wrappedContent + '<br>';
                } else {
                    // If it doesn't end with "...Lue lisää", append the original content
                    featuredReview.innerHTML += reviewContentClone + '<br>';
                }

                // Clone and append the reviewer
                const nameContentClone = name.innerText;
                featuredReview.innerHTML += nameContentClone;
  
                console.log('Featured review updated successfully!');
            } else {
                console.error('No element found with id "featured-review"');
            }
  
            // Once we find the elements and update, stop checking
            observer.disconnect();
            clearInterval(intervalCheck);
        }
    }
  }
  
  // MutationObserver callback to monitor for changes in the DOM
  const observer = new MutationObserver((mutationsList, observer) => {
    // Check if the review list and reviews are present after any DOM change
    if (document.querySelector('.yotpo-reviews-list') && document.querySelector('.yotpo-review')) {
        updateFeaturedReview();
    }
  });
  
  // Start observing changes in the body or a specific container
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Additionally, use setInterval to check periodically in case MutationObserver misses it
  const intervalCheck = setInterval(() => {
    if (document.querySelector('.yotpo-reviews-list') && document.querySelector('.yotpo-review')) {
        updateFeaturedReview();
    }
  }, 1000); // Check every 1 second
  
  // Optional timeout after which to stop checking
  setTimeout(() => {
    clearInterval(intervalCheck);
    observer.disconnect();
  }, 15000); // Stop after 15 seconds
  